/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.installs.rpc.MarketplaceInstallsRpc
 */

/* @bend-expect import-missing-runtime-dep */
import { useMemo } from 'react';
import {
  useQuery,
  useLazyQuery,
  useSuspenseQuery,
  QueryHookOptions,
  LazyQueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryResultTuple,
  QueryResult,
  UseSuspenseQueryResult,
} from 'data-fetching-client';
import * as References from './MarketplaceInstallsRpc-app';
import * as Queries from './MarketplaceInstallsRpc-app.dfc.new';
import type { AdditionalContextArgs } from './MarketplaceInstallsRpc-app.dfc.new';

type OverrideData<TTuple extends [any, any], TNewData> = [
  TTuple[0],
  Omit<TTuple[1], 'data'> & { data?: TNewData },
];

type LazyQueryResultTupleOverride<
  Response,
  Request extends Record<string, any>,
  DataOverride,
> = OverrideData<LazyQueryResultTuple<Response, Request>, DataOverride>;

type UseGetInstallCountQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetInstallCountResponseType>,
    References.GetInstallCountRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<'getInstallCount', References.GetInstallCountResponseType>
        : References.GetInstallCountResponseType)
    | undefined;
};

export function useGetInstallCountQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetInstallCountResponseType>,
    References.GetInstallCountRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetInstallCountQueryReturn<T> {
  const { data, ...rest } = useQuery(Queries.GET_INSTALL_COUNT_QUERY, options);

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getInstallCount: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetInstallCountQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseGetInstallCountQueryReturn<T>;
}

type UseGetInstallCountLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetInstallCountResponseType>,
    References.GetInstallCountRequestType,
    T extends true
      ? Record<'getInstallCount', References.GetInstallCountResponseType>
      : References.GetInstallCountResponseType
  >;

export function useGetInstallCountLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetInstallCountResponseType>,
    References.GetInstallCountRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetInstallCountLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_INSTALL_COUNT_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getInstallCount: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetInstallCountLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetInstallCountLazyQueryReturn<T>;
}

type UseGetInstallCountSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetInstallCountResponseType>,
    References.GetInstallCountRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'getInstallCount', References.GetInstallCountResponseType>
    : References.GetInstallCountResponseType;
};

export function useGetInstallCountSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetInstallCountResponseType>,
    References.GetInstallCountRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetInstallCountSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_INSTALL_COUNT_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getInstallCount: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetInstallCountSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetInstallCountSuspenseQueryReturn<T>;
}

type UseGetInstallCountBatchQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetInstallCountBatchResponseType>,
    References.GetInstallCountBatchRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getInstallCountBatch',
            References.GetInstallCountBatchResponseType
          >
        : References.GetInstallCountBatchResponseType)
    | undefined;
};

export function useGetInstallCountBatchQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetInstallCountBatchResponseType>,
    References.GetInstallCountBatchRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetInstallCountBatchQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_INSTALL_COUNT_BATCH_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getInstallCountBatch: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetInstallCountBatchQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetInstallCountBatchQueryReturn<T>;
}

type UseGetInstallCountBatchLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetInstallCountBatchResponseType>,
    References.GetInstallCountBatchRequestType,
    T extends true
      ? Record<
          'getInstallCountBatch',
          References.GetInstallCountBatchResponseType
        >
      : References.GetInstallCountBatchResponseType
  >;

export function useGetInstallCountBatchLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetInstallCountBatchResponseType>,
    References.GetInstallCountBatchRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetInstallCountBatchLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_INSTALL_COUNT_BATCH_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getInstallCountBatch: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetInstallCountBatchLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetInstallCountBatchLazyQueryReturn<T>;
}

type UseGetInstallCountBatchSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetInstallCountBatchResponseType>,
    References.GetInstallCountBatchRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'getInstallCountBatch',
        References.GetInstallCountBatchResponseType
      >
    : References.GetInstallCountBatchResponseType;
};

export function useGetInstallCountBatchSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetInstallCountBatchResponseType>,
    References.GetInstallCountBatchRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetInstallCountBatchSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_INSTALL_COUNT_BATCH_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getInstallCountBatch: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetInstallCountBatchSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetInstallCountBatchSuspenseQueryReturn<T>;
}

type UseSendInstallIntentQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.SendInstallIntentResponseType>,
    References.SendInstallIntentRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<'sendInstallIntent', References.SendInstallIntentResponseType>
        : References.SendInstallIntentResponseType)
    | undefined;
};

export function useSendInstallIntentQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.SendInstallIntentResponseType>,
    References.SendInstallIntentRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseSendInstallIntentQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.SEND_INSTALL_INTENT_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            sendInstallIntent: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseSendInstallIntentQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseSendInstallIntentQueryReturn<T>;
}

type UseSendInstallIntentLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.SendInstallIntentResponseType>,
    References.SendInstallIntentRequestType,
    T extends true
      ? Record<'sendInstallIntent', References.SendInstallIntentResponseType>
      : References.SendInstallIntentResponseType
  >;

export function useSendInstallIntentLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.SendInstallIntentResponseType>,
    References.SendInstallIntentRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseSendInstallIntentLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.SEND_INSTALL_INTENT_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            sendInstallIntent: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseSendInstallIntentLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseSendInstallIntentLazyQueryReturn<T>;
}

type UseSendInstallIntentSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.SendInstallIntentResponseType>,
    References.SendInstallIntentRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'sendInstallIntent', References.SendInstallIntentResponseType>
    : References.SendInstallIntentResponseType;
};

export function useSendInstallIntentSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.SendInstallIntentResponseType>,
    References.SendInstallIntentRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseSendInstallIntentSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.SEND_INSTALL_INTENT_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            sendInstallIntent: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseSendInstallIntentSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseSendInstallIntentSuspenseQueryReturn<T>;
}

type UseGetInstallCompatibilityQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetInstallCompatibilityResponseType>,
    References.GetInstallCompatibilityRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getInstallCompatibility',
            References.GetInstallCompatibilityResponseType
          >
        : References.GetInstallCompatibilityResponseType)
    | undefined;
};

export function useGetInstallCompatibilityQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetInstallCompatibilityResponseType>,
    References.GetInstallCompatibilityRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetInstallCompatibilityQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_INSTALL_COMPATIBILITY_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getInstallCompatibility: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetInstallCompatibilityQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetInstallCompatibilityQueryReturn<T>;
}

type UseGetInstallCompatibilityLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetInstallCompatibilityResponseType>,
    References.GetInstallCompatibilityRequestType,
    T extends true
      ? Record<
          'getInstallCompatibility',
          References.GetInstallCompatibilityResponseType
        >
      : References.GetInstallCompatibilityResponseType
  >;

export function useGetInstallCompatibilityLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetInstallCompatibilityResponseType>,
    References.GetInstallCompatibilityRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetInstallCompatibilityLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_INSTALL_COMPATIBILITY_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getInstallCompatibility: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetInstallCompatibilityLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetInstallCompatibilityLazyQueryReturn<T>;
}

type UseGetInstallCompatibilitySuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetInstallCompatibilityResponseType>,
    References.GetInstallCompatibilityRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'getInstallCompatibility',
        References.GetInstallCompatibilityResponseType
      >
    : References.GetInstallCompatibilityResponseType;
};

export function useGetInstallCompatibilitySuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetInstallCompatibilityResponseType>,
    References.GetInstallCompatibilityRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetInstallCompatibilitySuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_INSTALL_COMPATIBILITY_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getInstallCompatibility: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetInstallCompatibilitySuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetInstallCompatibilitySuspenseQueryReturn<T>;
}

type UseGetInstallabilityQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetInstallabilityResponseType>,
    References.GetInstallabilityRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<'getInstallability', References.GetInstallabilityResponseType>
        : References.GetInstallabilityResponseType)
    | undefined;
};

export function useGetInstallabilityQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetInstallabilityResponseType>,
    References.GetInstallabilityRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetInstallabilityQueryReturn<T> {
  const { data, ...rest } = useQuery(Queries.GET_INSTALLABILITY_QUERY, options);

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getInstallability: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetInstallabilityQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseGetInstallabilityQueryReturn<T>;
}

type UseGetInstallabilityLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetInstallabilityResponseType>,
    References.GetInstallabilityRequestType,
    T extends true
      ? Record<'getInstallability', References.GetInstallabilityResponseType>
      : References.GetInstallabilityResponseType
  >;

export function useGetInstallabilityLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetInstallabilityResponseType>,
    References.GetInstallabilityRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetInstallabilityLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_INSTALLABILITY_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getInstallability: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetInstallabilityLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetInstallabilityLazyQueryReturn<T>;
}

type UseGetInstallabilitySuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetInstallabilityResponseType>,
    References.GetInstallabilityRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'getInstallability', References.GetInstallabilityResponseType>
    : References.GetInstallabilityResponseType;
};

export function useGetInstallabilitySuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetInstallabilityResponseType>,
    References.GetInstallabilityRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetInstallabilitySuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_INSTALLABILITY_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getInstallability: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetInstallabilitySuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetInstallabilitySuspenseQueryReturn<T>;
}

type UseGetOAuthUrlQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetOAuthUrlResponseType>,
    References.GetOAuthUrlRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<'getOAuthUrl', References.GetOAuthUrlResponseType>
        : References.GetOAuthUrlResponseType)
    | undefined;
};

export function useGetOAuthUrlQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetOAuthUrlResponseType>,
    References.GetOAuthUrlRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetOAuthUrlQueryReturn<T> {
  const { data, ...rest } = useQuery(Queries.GET_OAUTH_URL_QUERY, options);

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getOAuthUrl: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return { data: legacyFormatData, ...rest } as UseGetOAuthUrlQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseGetOAuthUrlQueryReturn<T>;
}

type UseGetOAuthUrlLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetOAuthUrlResponseType>,
    References.GetOAuthUrlRequestType,
    T extends true
      ? Record<'getOAuthUrl', References.GetOAuthUrlResponseType>
      : References.GetOAuthUrlResponseType
  >;

export function useGetOAuthUrlLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetOAuthUrlResponseType>,
    References.GetOAuthUrlRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetOAuthUrlLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_OAUTH_URL_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getOAuthUrl: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetOAuthUrlLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetOAuthUrlLazyQueryReturn<T>;
}

type UseGetOAuthUrlSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetOAuthUrlResponseType>,
    References.GetOAuthUrlRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'getOAuthUrl', References.GetOAuthUrlResponseType>
    : References.GetOAuthUrlResponseType;
};

export function useGetOAuthUrlSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetOAuthUrlResponseType>,
    References.GetOAuthUrlRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetOAuthUrlSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_OAUTH_URL_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getOAuthUrl: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetOAuthUrlSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetOAuthUrlSuspenseQueryReturn<T>;
}

type UseGetInstallExemptionStatusQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetInstallExemptionStatusResponseType>,
    References.GetInstallExemptionStatusRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getInstallExemptionStatus',
            References.GetInstallExemptionStatusResponseType
          >
        : References.GetInstallExemptionStatusResponseType)
    | undefined;
};

export function useGetInstallExemptionStatusQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetInstallExemptionStatusResponseType>,
    References.GetInstallExemptionStatusRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetInstallExemptionStatusQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_INSTALL_EXEMPTION_STATUS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getInstallExemptionStatus: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetInstallExemptionStatusQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetInstallExemptionStatusQueryReturn<T>;
}

type UseGetInstallExemptionStatusLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetInstallExemptionStatusResponseType>,
    References.GetInstallExemptionStatusRequestType,
    T extends true
      ? Record<
          'getInstallExemptionStatus',
          References.GetInstallExemptionStatusResponseType
        >
      : References.GetInstallExemptionStatusResponseType
  >;

export function useGetInstallExemptionStatusLazyQuery<
  T extends boolean = false,
>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetInstallExemptionStatusResponseType>,
    References.GetInstallExemptionStatusRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetInstallExemptionStatusLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_INSTALL_EXEMPTION_STATUS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getInstallExemptionStatus: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetInstallExemptionStatusLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetInstallExemptionStatusLazyQueryReturn<T>;
}

type UseGetInstallExemptionStatusSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetInstallExemptionStatusResponseType>,
    References.GetInstallExemptionStatusRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'getInstallExemptionStatus',
        References.GetInstallExemptionStatusResponseType
      >
    : References.GetInstallExemptionStatusResponseType;
};

export function useGetInstallExemptionStatusSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetInstallExemptionStatusResponseType>,
    References.GetInstallExemptionStatusRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetInstallExemptionStatusSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_INSTALL_EXEMPTION_STATUS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getInstallExemptionStatus: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetInstallExemptionStatusSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetInstallExemptionStatusSuspenseQueryReturn<T>;
}

type UseGetRequiredScopeGroupsQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetRequiredScopeGroupsResponseType>,
    References.GetRequiredScopeGroupsRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getRequiredScopeGroups',
            References.GetRequiredScopeGroupsResponseType
          >
        : References.GetRequiredScopeGroupsResponseType)
    | undefined;
};

export function useGetRequiredScopeGroupsQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetRequiredScopeGroupsResponseType>,
    References.GetRequiredScopeGroupsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetRequiredScopeGroupsQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_REQUIRED_SCOPE_GROUPS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getRequiredScopeGroups: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetRequiredScopeGroupsQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetRequiredScopeGroupsQueryReturn<T>;
}

type UseGetRequiredScopeGroupsLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetRequiredScopeGroupsResponseType>,
    References.GetRequiredScopeGroupsRequestType,
    T extends true
      ? Record<
          'getRequiredScopeGroups',
          References.GetRequiredScopeGroupsResponseType
        >
      : References.GetRequiredScopeGroupsResponseType
  >;

export function useGetRequiredScopeGroupsLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetRequiredScopeGroupsResponseType>,
    References.GetRequiredScopeGroupsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetRequiredScopeGroupsLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_REQUIRED_SCOPE_GROUPS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getRequiredScopeGroups: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetRequiredScopeGroupsLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetRequiredScopeGroupsLazyQueryReturn<T>;
}

type UseGetRequiredScopeGroupsSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetRequiredScopeGroupsResponseType>,
    References.GetRequiredScopeGroupsRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'getRequiredScopeGroups',
        References.GetRequiredScopeGroupsResponseType
      >
    : References.GetRequiredScopeGroupsResponseType;
};

export function useGetRequiredScopeGroupsSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetRequiredScopeGroupsResponseType>,
    References.GetRequiredScopeGroupsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetRequiredScopeGroupsSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_REQUIRED_SCOPE_GROUPS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getRequiredScopeGroups: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetRequiredScopeGroupsSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetRequiredScopeGroupsSuspenseQueryReturn<T>;
}

type UseCheckRequiredScopeGroupsInSyncQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.CheckRequiredScopeGroupsInSyncResponseType>,
    References.CheckRequiredScopeGroupsInSyncRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'checkRequiredScopeGroupsInSync',
            References.CheckRequiredScopeGroupsInSyncResponseType
          >
        : References.CheckRequiredScopeGroupsInSyncResponseType)
    | undefined;
};

export function useCheckRequiredScopeGroupsInSyncQuery<
  T extends boolean = false,
>(
  options?: QueryHookOptions<
    Record<'result', References.CheckRequiredScopeGroupsInSyncResponseType>,
    References.CheckRequiredScopeGroupsInSyncRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseCheckRequiredScopeGroupsInSyncQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.CHECK_REQUIRED_SCOPE_GROUPS_IN_SYNC_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            checkRequiredScopeGroupsInSync: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseCheckRequiredScopeGroupsInSyncQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseCheckRequiredScopeGroupsInSyncQueryReturn<T>;
}

type UseCheckRequiredScopeGroupsInSyncLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.CheckRequiredScopeGroupsInSyncResponseType>,
    References.CheckRequiredScopeGroupsInSyncRequestType,
    T extends true
      ? Record<
          'checkRequiredScopeGroupsInSync',
          References.CheckRequiredScopeGroupsInSyncResponseType
        >
      : References.CheckRequiredScopeGroupsInSyncResponseType
  >;

export function useCheckRequiredScopeGroupsInSyncLazyQuery<
  T extends boolean = false,
>(
  options?: LazyQueryHookOptions<
    Record<'result', References.CheckRequiredScopeGroupsInSyncResponseType>,
    References.CheckRequiredScopeGroupsInSyncRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseCheckRequiredScopeGroupsInSyncLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.CHECK_REQUIRED_SCOPE_GROUPS_IN_SYNC_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            checkRequiredScopeGroupsInSync: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseCheckRequiredScopeGroupsInSyncLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseCheckRequiredScopeGroupsInSyncLazyQueryReturn<T>;
}

type UseCheckRequiredScopeGroupsInSyncSuspenseQueryReturn<T extends boolean> =
  Omit<
    UseSuspenseQueryResult<
      Record<'result', References.CheckRequiredScopeGroupsInSyncResponseType>,
      References.CheckRequiredScopeGroupsInSyncRequestType
    >,
    'data'
  > & {
    data: T extends true
      ? Record<
          'checkRequiredScopeGroupsInSync',
          References.CheckRequiredScopeGroupsInSyncResponseType
        >
      : References.CheckRequiredScopeGroupsInSyncResponseType;
  };

export function useCheckRequiredScopeGroupsInSyncSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.CheckRequiredScopeGroupsInSyncResponseType>,
    References.CheckRequiredScopeGroupsInSyncRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseCheckRequiredScopeGroupsInSyncSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.CHECK_REQUIRED_SCOPE_GROUPS_IN_SYNC_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            checkRequiredScopeGroupsInSync: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseCheckRequiredScopeGroupsInSyncSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseCheckRequiredScopeGroupsInSyncSuspenseQueryReturn<T>;
}
